/* eslint-disable import/prefer-default-export */

import React from 'react';
import { get } from 'lodash';
import { Trans } from 'lingui-react';

export const pickTranslationForValue = (value, translations) => (
  <Trans id={get(translations, (value || '').toUpperCase(), value)} />
);



// WEBPACK FOOTER //
// ./src/components/FieldUpdates/utils.js